import { Route } from 'react-router-dom';
import { RouteItem } from '../../../libs/IdeLink.Web.Common/src/types/RouteItem';

import { Page403Loading } from './Page403Loading';

export const getPage403Route = (): RouteItem => ({
    render: Route,
    props: {
        path: '/403',
        component: Page403Loading,
    },
});
